<template>
  <div>
    <h2 class="text-xl font-semibold mb-2">Call Stats</h2>
    <p class="text-n-slate-11">Call statistics will appear here.</p>
  </div>
</template>

<script setup>
</script>
